// delta-02 — tradução gerada a partir de scripts/i18n/out/missing-es.json
const catalogo: Record<string, string> = {
    "%{arg1} achievements criados.": "%{arg1} achievements creados.",
    "%{arg1} arquivo(s) não estavam mais no storage e ficaram de fora do zip.": "%{arg1} archivo(s) ya no estaban en el storage y quedaron fuera del zip.",
    "%{arg1}: %{arg2}": "%{arg1}: %{arg2}",
    "(você)": "(usted)",
    "0 3px 12px rgba(0,0,0,.5)": "0 3px 12px rgba(0,0,0,.5)",
    "0 4px 14px rgba(0,0,0,.28)": "0 4px 14px rgba(0,0,0,.28)",
    "0.72rem": "0.72rem",
    "0.78rem": "0.78rem",
    "0.7rem": "0.7rem",
    "1 arquivo": "1 archivo",
    "1px dashed grey": "1px dashed grey",
    "1px solid #ccc": "1px solid #ccc",
    "1px solid rgba(0,0,0,0.06)": "1px solid rgba(0,0,0,0.06)",
    "25% atinge": "25% alcanza",
    "30px": "30px",
    "40px": "40px",
    "50% atinge": "50% alcanza",
    "75% atinge": "75% alcanza",
    "8px": "8px",
    "A rede ainda está em rascunho: envie para a geração antes de rodar o gerador.": "La red todavía está en borrador: envíela a generación antes de ejecutar el generador.",
    "A roda deu outro giro ao cliente": "La ruleta le dio otro giro al cliente",
    "ASC": "ASC",
    "Acertou": "Acertó",
    "Acessível": "Accesible",
    "Aguardando o cliente girar": "Esperando a que el cliente gire",
    "Aguardando palpite": "Esperando pronóstico",
    "Ainda não disponível": "Todavía no disponible",
    "Analisar histórico": "Analizar historial",
    "Arquivo inválido": "Archivo inválido",
    "Ativar": "Activar",
    "Atualizando…": "Actualizando…",
    "Atualizar cache do app": "Actualizar caché de la aplicación",
    "Campo de combustíveis está vazio": "El campo de combustibles está vacío",
    "Campo de dias da semana está vazio": "El campo de días de la semana está vacío",
    "Campo de postos está vazio": "El campo de estaciones está vacío",
    "Campo nome do quadro está vazio": "El campo nombre del tablero está vacío",
    "Campo nome está vazio": "El campo nombre está vacío",
    "Cliente %{arg1} com sucesso": "Cliente %{arg1} con éxito",
    "Cor da fonte na home": "Color de la fuente en el inicio",
    "Cor do botão de cadastro": "Color del botón de registro",
    "Cor do botão de login": "Color del botón de login",
    "Cor secundária": "Color secundario",
    "Cupom Utilizado": "Cupón Utilizado",
    "Data final não pode ser inferior a data inicial": "La fecha final no puede ser anterior a la fecha inicial",
    "Defina o tipo de frequência": "Defina el tipo de frecuencia",
    "Defina um horário de início e fim": "Defina un horario de inicio y fin",
    "Defina uma data de início e fim": "Defina una fecha de inicio y fin",
    "Defina uma data válida": "Defina una fecha válida",
    "Desafiador": "Desafiante",
    "Desativar": "Desactivar",
    "Desativar quadro": "Desactivar tablero",
    "Disponível": "Disponible",
    "Dispositivo %{arg1}": "Dispositivo %{arg1}",
    "Duração inválida": "Duración inválida",
    "Ele coloca a logo da rede no modelo aprovado da CTTX — o desenho e o azul são sempre os mesmos — e leva alguns segundos.": "Coloca el logo de la red en la plantilla aprobada de CTTX — el diseño y el azul son siempre los mismos — y demora algunos segundos.",
    "Ele usa a CLI do Claude autenticada na sua máquina para desenhar uma peça nova com a logo e a cor da rede. Cada peça leva por volta de 13 minutos.": "Usa la CLI de Claude autenticada en su máquina para diseñar una pieza nueva con el logo y el color de la red. Cada pieza demora alrededor de 13 minutos.",
    "Em atraso": "Vencido",
    "Em dia": "Al día",
    "Envio ativo — novos disparos serão realizados automaticamente conforme o agendamento configurado.": "Envío activo — los nuevos envíos se realizarán automáticamente según la programación configurada.",
    "Envio pausado — nenhum novo disparo será gerado enquanto estiver nesse estado. Disparos já agendados são cancelados ao pausar.": "Envío pausado — no se generará ningún nuevo envío mientras esté en este estado. Los envíos ya programados se cancelan al pausar.",
    "Envio recorrente atualizado. %{arg1}": "Envío recurrente actualizado. %{arg1}",
    "Envio recorrente criado. %{arg1}": "Envío recurrente creado. %{arg1}",
    "Erro ao %{arg1} cliente": "Error al %{arg1} cliente",
    "Erro ao %{arg1} rede": "Error al %{arg1} red",
    "Escolha um número de prioridade na faixa de %{arg1} a %{arg2}, onde valores mais baixos indicam prioridades mais elevadas. Lembre-se que cada número de prioridade é destinado a um único anúncio ativo.": "Elija un número de prioridad en el rango de %{arg1} a %{arg2}, donde los valores más bajos indican prioridades más altas. Recuerde que cada número de prioridad está destinado a un único anuncio activo.",
    "Escolher no seletor": "Elegir en el selector",
    "Executar agora": "Ejecutar ahora",
    "Falha ao enviar %{arg1}: %{arg2}": "Error al enviar %{arg1}: %{arg2}",
    "Ganhou direito desde": "Ganó el derecho desde",
    "Ganhou outro giro": "Ganó otro giro",
    "Girou e ganhou": "Giró y ganó",
    "Hex inválido": "Hex inválido",
    "Horário de fim não pode ser inferior ao horário de início": "El horario de fin no puede ser anterior al horario de inicio",
    "Informe uma cor válida": "Ingrese un color válido",
    "Iniciando…": "Iniciando…",
    "Migração concluída: %{arg1}.": "Migración completada: %{arg1}.",
    "Moderado": "Moderado",
    "Monta o comando do gerador para esta rede": "Arma el comando del generador para esta red",
    "Montando o zip…": "Armando el zip…",
    "Nenhum combustível selecionado": "Ningún combustible seleccionado",
    "Nenhuma meta foi definida": "Ningún objetivo fue definido",
    "O giro venceu antes de o cliente usar": "El giro venció antes de que el cliente lo usara",
    "Ofertas disponíveis": "Ofertas disponibles",
    "PDF %{arg1}": "PDF %{arg1}",
    "Palpite enviado": "Pronóstico enviado",
    "Palpitou": "Pronosticó",
    "Palpitou desde": "Pronosticó desde",
    "Passou a vez": "Pasó el turno",
    "Pausado": "Pausado",
    "Pausar": "Pausar",
    "Pausar envio": "Pausar envío",
    "Perdeu": "Perdió",
    "Permitido arquivos de até %{arg1}": "Se permiten archivos de hasta %{arg1}",
    "Postos e Combustíveis": "Estaciones y Combustibles",
    "Postos e Combústivel": "Estaciones y Combustible",
    "Prioridade inválida": "Prioridad inválida",
    "Quadro desativado": "Tablero desactivado",
    "Rede %{arg1} com sucesso": "Red %{arg1} con éxito",
    "Retomar": "Reanudar",
    "Retomar envio": "Reanudar envío",
    "Saldo cashback": "Saldo cashback",
    "Saldo em pontos": "Saldo en puntos",
    "Sem combustíveis": "Sin combustibles",
    "Sem informações": "Sin información",
    "Sem palpite": "Sin pronóstico",
    "Sem postos": "Sin estaciones",
    "Tanque Cheio": "Tanque Lleno",
    "Transforme a recompensa do Clube num giro: monte as fatias, defina peso e estoque, simule o custo e acompanhe quem girou e o que ganhou.": "Transforme la recompensa del Club en un giro: arme las fracciones, defina peso y stock, simule el costo y siga quién giró y qué ganó.",
    "Upload": "Cargar",
    "Utilizado": "Utilizado",
    "Você poderá aplicá-las no próximo passo": "Podrá aplicarlas en el próximo paso",
    "_Sem notas._": "_Sin notas._",
    "auto": "auto",
    "briefing": "briefing",
    "calc(100% - 20px)": "calc(100% - 20px)",
    "chain-background.png": "chain-background.png",
    "chain-header-background.png": "chain-header-background.png",
    "chains": "chains",
    "chains/chainId/stations": "chains/chainId/stations",
    "draft": "draft",
    "duration": "duration",
    "image": "image",
    "img": "img",
    "italic": "italic",
    "legend": "legend",
    "name": "name",
    "processed": "processed",
    "promoters": "promoters",
    "red": "red",
    "rgba(0,0,0,0.03)": "rgba(0,0,0,0.03)",
    "rgba(102,126,234,0.6)": "rgba(102,126,234,0.6)",
    "sem artboard nesta rodada — fundo é o campo da marca": "sin artboard en esta ronda — el fondo es el campo de la marca",
    "sem fundo": "sin fondo",
    "sem nome": "sin nombre",
    "span": "span",
    "stations": "stations",
    "text.secondary": "text.secondary",
    "todos os postos": "todas las estaciones",
    "welcome": "welcome",
    "🎉 Ganhou": "🎉 Ganó",
};

export default catalogo;
